import { IRootState } from '../root_reducer';

import { ThunkAction } from 'redux-thunk';

import { BrandInfoApi } from 'providers/api';
import { BrandInfoApiResponse, BrandInfoInstrumentsApiResponse, BrandInfoModels, BrandInfoModelsApiResponse, BrandInfoPager, BrandsInfoApiResponse, BrandsInfoModel } from 'types/drupal/BrandInfo';
import { InventoryInstrument } from 'types/drupal/InstrumentNode';

const GET_BRANDINFO = 'gruhn-guitars-modern/inventory/GET_BRANDINFO';
const GET_BRANDINFO_SUCCESS = 'gruhn-guitars-modern/inventory/GET_BRANDINFO_SUCCESS';
const GET_BRANDINFO_FAIL = 'gruhn-guitars-modern/inventory/GET_BRANDINFO_FAIL';
const SET_BRANDINFO_BRAND = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_BRAND';
const SET_BRANDINFO_IMAGE = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_IMAGE';
const SET_BRANDINFO_MODEL = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_MODEL';
const SET_BRANDINFO_INSTRUMENTS = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_INSTRUMENTS';
const SET_BRANDINFO_CONTENT = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_CONTENT';
const SET_BRANDINFO_PAGER = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_PAGER';
const SET_BRANDINFO_PERPAGE = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_PERPAGE';
const SET_BRANDINFO_MODELS = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_MODELS';
const SET_BRANDINFO_TITLE = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_TITLE';
const SET_BRANDINFO_DEFAULT_YEAR = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_DEFAULT_YEAR';
const SET_BRANDINFO_META_TITLE = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_META_TITLE';
const SET_BRANDINFO_META_DESC = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_META_DESC';

const GET_BRANDSINFO = 'gruhn-guitars-modern/inventory/GET_BRANDINFO';
const GET_BRANDSINFO_SUCCESS = 'gruhn-guitars-modern/inventory/GET_BRANDINFO_SUCCESS';
const GET_BRANDSINFO_FAIL = 'gruhn-guitars-modern/inventory/GET_BRANDINFO_FAIL';
const SET_BRANDSINFO_FETCHING = 'gruhn-guitars-modern/inventory/SET_BRANDINFO_FETCHING';
const SET_BRANDSINFO_BRANDS = 'gruhn-guitars-modern/inventory/SET_BRANDSINFO_BRANDS';

export interface BrandInfoAction {
    brandContent: string;
    brandDefaultYear: string;
    brandImageUrl: string;
    brandInstruments: InventoryInstrument[];
    brandMetaDesc: string;
    brandMetaTitle: string;
    brandModel: string;
    brandName: string;
    brandPager: BrandInfoPager;
    brandTitle: string;
    brands: BrandsInfoModel[];
    perPage: number;
    type: string;
    brandModels: BrandInfoModels[];
    fetching: boolean;
}

export interface BrandInfoState {
    brandContent: string;
    brandDefaultYear: string;
    brandImageUrl: string;
    brandInstruments: InventoryInstrument[];
    brandMetaTitle: string;
    brandMetaDesc: string;
    brandModel: string;
    brandModels: BrandInfoModels[];
    brandName: string;
    brandPager: BrandInfoPager;
    brandTitle: string;
    brands: BrandsInfoModel[];
    failed: boolean;
    fetching: boolean;
}

const initialState: BrandInfoState = {
    brandContent: '',
    brandDefaultYear: '',
    brandImageUrl:'',
    brandInstruments: [],
    brandMetaDesc: '',
    brandMetaTitle: '',
    brandModel: '',
    brandModels: [],
    brandName: '',
    brandPager: { currentPage: 1, lastPage:0, perPage:12, total:0 },
    brandTitle: '',
    brands: [],
    failed: false,
    fetching: false
};

export default function (state: BrandInfoState = initialState, action: BrandInfoAction): BrandInfoState {
    switch (action.type) {
        case GET_BRANDINFO :
            return { ...state };
        case GET_BRANDINFO_SUCCESS :
            return { ...state, failed: false };
        case GET_BRANDINFO_FAIL :
            return { ...state , failed: true };
        case SET_BRANDINFO_INSTRUMENTS:
            const { brandInstruments } = action;
            return { ...state, brandInstruments };
        case SET_BRANDINFO_CONTENT:
            const { brandContent } = action;
            return { ...state, brandContent };
        case SET_BRANDINFO_DEFAULT_YEAR:
            const { brandDefaultYear } = action;
            return { ...state, brandDefaultYear };
        case SET_BRANDINFO_IMAGE:
            const { brandImageUrl } = action;
            return { ...state, brandImageUrl };
        case SET_BRANDINFO_BRAND:
            const { brandName } = action;
            return { ...state, brandName };
        case SET_BRANDINFO_MODEL:
            const { brandModel } = action;
            return { ...state, brandModel };
        case SET_BRANDINFO_PAGER:
            const { brandPager } = action;
            return { ...state, brandPager };
        case SET_BRANDINFO_PERPAGE:
            const { perPage } = action;
            return { ...state, brandPager:  { ...state.brandPager, perPage } };
        case SET_BRANDINFO_MODELS:
            const { brandModels } = action;
            return { ...state, brandModels };
        case SET_BRANDINFO_TITLE:
            const { brandTitle } = action;
            return { ...state, brandTitle };
        case GET_BRANDSINFO:
            return { ...state };
        case GET_BRANDSINFO_SUCCESS :
            return { ...state, failed: false };
        case GET_BRANDSINFO_FAIL :
            return { ...state , failed: true };
        case SET_BRANDSINFO_FETCHING :
            const { fetching } = action;
            return { ...state , fetching };
        case SET_BRANDSINFO_BRANDS:
            const { brands } = action;
            return { ...state, brands };
        case SET_BRANDINFO_META_TITLE:
            const { brandMetaTitle } = action;
            return { ...state,  brandMetaTitle };
        case SET_BRANDINFO_META_DESC:
            const { brandMetaDesc } = action;
            return { ...state, brandMetaDesc };
        default:
            return state;
    }
}

export const sendInstrumentDataRequest = (brandName: string, year: string, page: string): ThunkAction<void, IRootState, null, any> => (dispatch, getState) => {
    const perPage =  getState().brandInfo.brandPager.perPage;
    const fetching = true;
    dispatch({ type: SET_BRANDSINFO_FETCHING, fetching });

    BrandInfoApi.getBrandInstruments(brandName, year, page, perPage)
        .then((brandInfo: BrandInfoInstrumentsApiResponse) => {
            const fetchingFalse = false;
            const brandModel = '';
            const brandInstruments = brandInfo.instruments.data;
            const brandPager: BrandInfoPager = {
                currentPage: brandInfo.instruments.current_page,
                lastPage: brandInfo.instruments.last_page,
                perPage: brandInfo.instruments.per_page,
                total: brandInfo.instruments.total
            };
            dispatch({ type: GET_BRANDINFO_SUCCESS });
            dispatch({ type: SET_BRANDINFO_INSTRUMENTS, brandInstruments });
            dispatch({ type: SET_BRANDINFO_PAGER, brandPager });
            dispatch({ type: SET_BRANDINFO_MODEL, brandModel });
            dispatch({ type: SET_BRANDSINFO_FETCHING, fetchingFalse });
        })
        .catch((error) => {
            dispatch({ type: GET_BRANDINFO_FAIL });
        });
};

export const sendInstrumentWithModelDataRequest = (brandName: string, brandModel: string, brandYear: string, page: string): ThunkAction<void, IRootState, null, any> => (dispatch, getState) => {
    const perPage =  getState().brandInfo.brandPager.perPage;

    const fetching = true;
    dispatch({ type: SET_BRANDSINFO_FETCHING, fetching });

    BrandInfoApi.getBrandInstrumentsWithModel(brandName, brandModel, brandYear, page, perPage)
        .then((brandInfo: BrandInfoInstrumentsApiResponse) => {
            const fetchingFalse = false;
            const brandInstruments = brandInfo.instruments.data;
            const brandPager: BrandInfoPager = {
                currentPage: brandInfo.instruments.current_page,
                lastPage: brandInfo.instruments.last_page,
                perPage: brandInfo.instruments.per_page,
                total: brandInfo.instruments.total
            };

            dispatch({ type: SET_BRANDSINFO_FETCHING, fetchingFalse });
            dispatch({ type: GET_BRANDINFO_SUCCESS });
            dispatch({ type: SET_BRANDINFO_INSTRUMENTS, brandInstruments });
            dispatch({ type: SET_BRANDINFO_PAGER, brandPager });
            dispatch({ type: SET_BRANDINFO_MODEL, brandModel });
        })
        .catch((error) => {
            dispatch({ type: GET_BRANDINFO_FAIL });
        });
};

export const sendModelsDataRequest = (brandName: string, year: string): ThunkAction<void, IRootState, null, any> => (dispatch, getState) => {
    BrandInfoApi.getBrandModels(brandName, year)
        .then((brandModels: BrandInfoModelsApiResponse) => {
            dispatch({ type: SET_BRANDINFO_MODELS, brandModels });
        })
        .catch((error) => {
            dispatch({ type: GET_BRANDINFO_FAIL });
        });
};

export const sendDataRequest = (brandNameInput: string): ThunkAction<void, IRootState, null, any> => (dispatch, getState) => {
    BrandInfoApi.getBrand(brandNameInput)
        .then((brandInfo: BrandInfoApiResponse) => {
            const brandName = brandInfo.brand_name.value;
            const brandContent = brandInfo.body.value;
            const brandImageUrl = brandInfo.field_image.file.url;
            const brandTitle = brandInfo.title;
            const brandDefaultYear = brandInfo.default_year.value;
            const brandMetaTitle = brandInfo.meta_title;
            const brandMetaDesc = brandInfo.meta_description;
            dispatch({ type: SET_BRANDINFO_DEFAULT_YEAR, brandDefaultYear });
            dispatch({ type: SET_BRANDINFO_CONTENT, brandContent });
            dispatch({ type: SET_BRANDINFO_IMAGE, brandImageUrl });
            dispatch({ type: SET_BRANDINFO_TITLE, brandTitle });
            dispatch({ type: SET_BRANDINFO_BRAND, brandName });
            dispatch({ type: SET_BRANDINFO_META_TITLE, brandMetaTitle });
            dispatch({ type: SET_BRANDINFO_META_DESC, brandMetaDesc });
        })
        .catch((error) => {
            dispatch({ type: GET_BRANDINFO_FAIL });
        });
};

export const sendBrandsDataRequest = (): ThunkAction<void, IRootState, null, any> => (dispatch, getState) => {
    BrandInfoApi.getBrands()
        .then((brands: BrandsInfoApiResponse) => {
            dispatch({ type: GET_BRANDSINFO_SUCCESS });
            dispatch({ type: SET_BRANDSINFO_BRANDS, brands });
        })
        .catch((error) => {
            dispatch({ type: GET_BRANDSINFO_FAIL });
        });
};

export const setPerPage = (perPage: string) => ({ type: SET_BRANDINFO_PERPAGE, perPage });



// WEBPACK FOOTER //
// ./src/redux/modules/brand-info.ts